

































































































































import {Vue, Component, Prop} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {GetCsRequest, DeleteCsAdminRequest, PutCsAdminRegisteredCsCsNoRequest} from 'supporter';

interface PageObj {
  page: number;
}

@Component({
  components: {CompSelectBox}
})
export default class CsListContent extends Vue {
  @Prop({
    default: (): any => [],
    required: false
  })
  @Prop({
    default: (): any => [],
    required: false
  })
  private orderProductOptionNoArr?: any;

  @Prop({default: true, required: true})
  private showAllLog?: boolean;

  private csList: any = [];
  private csAutoList: any[] = [];
  private needHandleList: any[] = [];
  private needHandleCsNums: number = 0;
  private processingCsNums: number = 0;

  private cs: any = {
    csStatusType: 'PROCESSING',
    csType: 'PRODUCT',
    csPathType: 'IN_BOUND',
    orderProductOptionNo: undefined,
    content: null
  };
  private csPathTypeArr: any[] = [
    {value: 'IN_BOUND', label: 'ORDER_CS_TASK_CS_PATH_TYPE_IN_BOUND'},
    {value: 'OUT_BOUND', label: 'ORDER_CS_TASK_CS_PATH_TYPE_OUT_BOUND'},
    {value: 'ETC', label: 'ORDER_CS_TASK_CS_PATH_TYPE_ETC'}
  ];
  private taskMessageStatusTypeArr: any[] = [
    {value: 'PROCESSING', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_STATUS_TYPE_PROCESSING'},
    {value: 'DONE', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_STATUS_TYPE_DONE'}
  ];
  private taskMessageTypeArr: any[] = [
    {value: 'PAY', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_PAY'},
    {value: 'PRODUCT', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_PRODUCT'},
    {value: 'DELIVERY', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_DELIVERY'},
    {value: 'CLAIM', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_CLAIM'},
    {value: 'REFUND', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_REFUND'},
    {value: 'ETC', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_ETC'}
  ];

  private mounted(): void {
    this.handleGetCs();
  }

  private handleClassName(item: any): any {
    let name: any = '';
    switch (item.csChannelType) {
      case 'SERVICE':
        name = 'contentContainer service cs_div';
        break;
      case 'FRONT':
        name = 'contentContainer front cs_div';
        break;
      case 'PARTNER':
        name = 'contentContainer partner cs_div';
        break;
      case 'BATCH':
        name = 'contentContainer batch cs_div';
        break;
      default:
        name = 'contentContainer service cs_div';
    }
    return name;
  }

  private handleCsComplated(theItem: any): void {
    let putCsRequest: PutCsAdminRegisteredCsCsNoRequest = {
      pathParams: {
        csNo: theItem.csNo
      },
      data: {
        orderNo: theItem.orderNo,
        csStatusType: 'DONE',
        csType: theItem.newCsType,
        orderOptionNo: theItem.newOrderOptionNo,
        csPathType: theItem.newCsPathType,
        content: theItem.newContent
      }
    };
    this.$api.putCsAdminRegisteredCsCsNo(putCsRequest).then((): any => {
      alert(this.$t('ORDER_CS_TASK_ALERT_12'));
      this.handleGetCs();
    });
  }
  private handlePutCs(theItem: any) {
    if (!theItem.newContent) {
      alert(this.$t('ORDER_CS_TASK_ALERT_10'));
      $(this.$refs['textarea' + theItem.csNo]).focus();
      return;
    }
    let putCsRequest: PutCsAdminRegisteredCsCsNoRequest = {
      pathParams: {
        csNo: theItem.csNo
      },
      data: {
        orderNo: theItem.orderNo,
        csStatusType: theItem.newCsStatusType,
        csType: theItem.newCsType,
        orderOptionNo: theItem.newOrderOptionNo,
        csPathType: theItem.newCsPathType,
        content: theItem.newContent
      }
    };
    this.$api.putCsAdminRegisteredCsCsNo(putCsRequest).then((): any => {
      alert(this.$t('ORDER_CS_TASK_ALERT_11'));
      this.handleGetCs();
    });
  }
  private csContentInput(ev: any): void {
    if (ev.newContent) {
      ev.contentLength = ev.newContent.length;
    } else {
      ev.contentLength = 0;
    }
  }
  private onClickDeleteBtn(csNo: any): void {
    if (!confirm(this.$t('ORDER_CS_TASK_CONFIRM_1') as any)) {
      return;
    }
    let deleteRequest: DeleteCsAdminRequest = {
      params: {
        csNos: csNo
      }
    };
    this.$api.deleteCsAdmin(deleteRequest).then((): any => {
      this.handleGetCs();
    });
  }
  private handelCancelEditCs(theItem: any): void {
    this.$set(theItem, 'showEdit', false);
    this.$set(theItem, 'contentLength', theItem.content.length);
    this.$set(theItem, 'newContent', theItem.content);
    this.$set(theItem, 'newCsStatusType', theItem.csStatusType);
    this.$set(theItem, 'newCsType', theItem.csType);
    this.$set(theItem, 'newCsPathType', theItem.csPathType);
    if (theItem.orderOptionNo) {
      this.$set(theItem, 'newOrderOptionNo', theItem.orderOptionNo);
    } else {
      this.$set(theItem, 'newOrderOptionNo', undefined);
    }
  }
  private handleEditCs(theItem: any) {
    this.$set(theItem, 'showEdit', true);
  }
  private getCsPathName(path: any): any {
    let name: any = '';
    switch (path) {
      case 'IN_BOUND':
        name = this.$t('ORDER_CS_TASK_CS_PATH_TYPE_IN_BOUND');
        break;
      case 'OUT_BOUND':
        name = this.$t('ORDER_CS_TASK_CS_PATH_TYPE_OUT_BOUND');
        break;
      case 'ETC':
        name = this.$t('ORDER_CS_TASK_CS_PATH_TYPE_ETC');
        break;
      default:
        name = '';
    }
    return name;
  }
  private getCsTypeName(csType: any): any {
    let name: any = '';
    switch (csType) {
      case 'PAY':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_PAY');
        break;
      case 'PRODUCT':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_PRODUCT');
        break;
      case 'DELIVERY':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_DELIVERY');
        break;
      case 'CLAIM':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_CLAIM');
        break;
      case 'REFUND':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_REFUND');
        break;
      case 'ETC':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_ETC');
        break;
      default:
        name = '';
    }
    return name;
  }
  private handleGetCs(): void {
    let csRequest: GetCsRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getCs(csRequest).then((res): any => {
      this.csList = [];
      this.csList = res.data;
      this.formatterCsList(res.data);
    });
  }
  private formatterCsList(arr: any): void {
    if (arr.length === 0) {
      return;
    }
    arr.map((item: any): any => {
      this.$set(item, 'contentLength', item.content.length);
      this.$set(item, 'newContent', item.content);
      this.$set(item, 'newCsStatusType', item.csStatusType);
      this.$set(item, 'newCsType', item.csType);
      this.$set(item, 'newCsPathType', item.csPathType);
      if (item.orderOptionNo) {
        this.$set(item, 'newOrderOptionNo', item.orderOptionNo);
      } else {
        this.$set(item, 'newOrderOptionNo', undefined);
      }
    });
    this.csAutoList = arr.filter((item: any): any => {
      return item.csPathType === 'SYSTEM';
    });
    this.needHandleList = arr.filter((item: any): any => {
      return item.csPathType !== 'SYSTEM';
    });
    this.needHandleCsNums = this.needHandleList.length;
    if (this.needHandleList.length > 0) {
      this.processingCsNums = this.needHandleList.filter((cs: any): any => {
        return cs.csStatusType === 'PROCESSING';
      }).length;
    }
    this.$emit('handleCsNums', this.needHandleCsNums, this.processingCsNums);
  }
  public replaceedContent(content){
    return content.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
}
